import { BidPoint } from "components/map/shared";
import { bidPointTypesEnum, routeTypesEnum } from "helpers/enums";
import { factEmptyDashLineStyle, factLineStyle, planLineStyle } from "helpers/map";
import React, { useEffect, useMemo, useState } from "react";
import { Polyline } from "react-leaflet";
import { getBidMainData } from "sources/books/bids";
import { getCarsRoutesByBidId, getRouteByBidId } from "sources/map";

const BidRoute = ({ bidId, setLoading, IdleLocation }) => {
    const [data, setData] = useState({ bid: null, route: null, carRoutes: null });

    useEffect(() => {
        if (!bidId) {
            return;
        }
        Promise.all([getBidMainData(bidId), getRouteByBidId(bidId), getCarsRoutesByBidId(bidId)]).then((res) => {
            setData({
                bid: res[0],
                route: res[1],
                carRoutes: res[2],
            });
            setLoading(false);
        });
    }, [bidId]);

    const planRoute = useMemo(() => {
        return (data.route?.segments || []).map((segment) => segment.points.map((point) => [point[1], point[0]]));
    }, [data.route]);
    const carRoute = useMemo(() => {
        const route = (data.carRoutes || []).find((item) => !item.isMobile);
        return route?.traveledRouteCoordinates || { [routeTypesEnum.EmptyMileage]: [], [routeTypesEnum.Main]: [] };
    }, [data.carRoutes]);
    const firstLoadPointIndex = useMemo(() => {
        return data.bid?.bidPoints.findIndex((item) =>
            [bidPointTypesEnum.LoadPoint, bidPointTypesEnum.UnloadPoint].includes(item.type),
        );
    }, [data.bid?.bidPoints]);

    if (!bidId) {
        return <IdleLocation />;
    }

    return (
        <>
            <Polyline positions={planRoute} {...planLineStyle} />
            <Polyline positions={carRoute[routeTypesEnum.EmptyMileage]} {...factEmptyDashLineStyle} />
            <Polyline positions={carRoute[routeTypesEnum.Main]} {...factLineStyle} color="#2dc581" />
            {data.bid?.bidPoints.map((point, i) => (
                <BidPoint
                    key={point.id}
                    index={i}
                    item={point}
                    bid={data.bid}
                    firstLoadPointIndex={firstLoadPointIndex}
                />
            ))}
            {data.bid?.bidPoints && <IdleLocation />}
        </>
    );
};

export default BidRoute;
